export const ButtonType = {
  primary: 'primary',
  outlined: 'outlined',
  white: 'white',
  ghost: 'ghost',
};
